import { render, staticRenderFns } from "./GoogleButton.vue?vue&type=template&id=3b96da8d"
import script from "./GoogleButton.vue?vue&type=script&lang=js"
export * from "./GoogleButton.vue?vue&type=script&lang=js"
import style0 from "./GoogleButton.vue?vue&type=style&index=0&id=3b96da8d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports